export default __webpack_public_path__ + "static/media/empty.41d10ff3.png";